module.exports = __webpack_public_path__ + "img/loading.26a0544.svg";